import React, { useEffect, useState, memo } from 'react'
import { apiService } from '../services/api';

function Pendaftaran() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await apiService.getPendaftaran()
        setData(res.data.pendaftaran)
      } catch (err) {
        setError('Gagal memuat data pendaftaran.')
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  if (loading) return <p className="text-center">Memuat...</p>
  if (error) return <p className="text-center text-red-500">{error}</p>
  if (!data || !data.isActive) return <p className="text-center">Pendaftaran saat ini belum dibuka.</p>

  return (
    <div className='min-h-screen bg-gray-100 lg:pt-24 pt-24 justify-center'>
      <div className="max-w-4xl mx-auto text-center mb-12 lg:px-0 px-6">
        <h1 className="lg:text-4xl text-xl font-bold text-center my-2">{data.title}</h1>
        <p className="text-body max-w-3xl mx-auto">{data.subtitle}</p>
      </div>

      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg lg:p-6 p-4 mb-8">
        {data.deskripsi.map((item, index) => (
          <p key={index} className="text-body max-w-3xl mx-auto mb-8">
            {item}
          </p>
        ))}
      </div>

      <div className="flex justify-center mb-8">
        <a
          href={data.link}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Daftar Sekarang
        </a>
      </div>

      <div className="flex justify-center mt-6 mb-8 space-x-4">
        <a
        href="/"
        className="text-left px-3 py-2 rounded-md lg:text-base text-sm font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors flex items-center"
        >
        🏠 Beranda
        </a>
      </div>
    </div>
  );
}

export default memo(Pendaftaran);
